import api from '../_api';

const actions = {
    getSeasons: ({commit}) => {

        return new Promise((resolve, reject) => {
            commit('RESET_STATE');
            commit('STATS_LOADING');

            api.getSeasons()
                .then((resp) => {
                    commit('SEASONS_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('STATS_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getDivisions: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('STATS_LOADING');

            api.getDivisions(payload.seasonId)
                .then((resp) => {
                    commit('DIVISIONS_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('STATS_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getTeams: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('STATS_LOADING');

            api.getTeams(payload.divisionId)
                .then((resp) => {
                    commit('TEAMS_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('STATS_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getStatsGame: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('STATS_LOADING');

            api.getStatsGame(payload.divisionId, payload.teamId)
                .then((resp) => {
                    commit('GAMES_SUCCESS', resp.data.data.games);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    commit('STATS_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getStats: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('STATS_LOADING');

            api.getStats(payload.divisionId, payload.teamId, payload.gameId)
                .then((resp) => {
                    commit('STATS_SUCCESS', resp.data.data.stats);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('STATS_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    clearStatsErrors:({commit}) => {
        commit('CLEAR_STATS_ERRORS');
    },
    clearStatsTeams:({commit}) => {
        commit('CLEAR_STATS_TEAMS');
    },
    clearStatsGames:({commit}) => {
        commit('CLEAR_STATS_GAMES');
    },
}

export default actions
